"use client";

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@tillix/ui-atoms/atoms/collapsible";
import { InfoIcon } from "lucide-react";

export default function NigoDisclaimer() {
  return (
    <Collapsible>
      <CollapsibleTrigger className="group flex items-center gap-2 text-muted-foreground text-sm transition-colors hover:text-foreground">
        <InfoIcon className="size-4" />
        <span>What is this form and why am I receiving it?</span>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="mt-3 rounded-md border border-border bg-muted/50 px-4 py-3 text-muted-foreground text-sm leading-relaxed">
          <p>
            A <strong>NIGO (Not In Good Order)</strong> notice means that your
            life insurance application or policy servicing request with
            Resolution Life is missing information needed to process it. This
            can happen when required fields were left blank, documentation was
            incomplete, or details could not be verified.
          </p>
          <p className="mt-2">
            To avoid delays in processing your policy, please review the items
            listed below and provide the requested information. Once submitted,
            Resolution Life will continue processing your request. If you have
            questions, please contact your agent or Resolution Life directly.
          </p>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
